import { render, staticRenderFns } from "./BudgetCreator.vue?vue&type=template&id=7b7754f0&scoped=true&"
import script from "./BudgetCreator.vue?vue&type=script&lang=js&"
export * from "./BudgetCreator.vue?vue&type=script&lang=js&"
import style0 from "./BudgetCreator.vue?vue&type=style&index=0&id=7b7754f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7754f0",
  null
  
)

export default component.exports